
import React from 'react';
import { Button } from '../../../components/base/Button';

export const HeroSection: React.FC = () => {
  return (
    <section className="relative h-80 overflow-hidden rounded-2xl mx-4 mb-6">
      <img
        src="https://public.readdy.ai/ai/img_res/0a645454305f7c502dc26e478be1fa40.jpg"
        alt="Family Shopping"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent">
        <div className="flex flex-col justify-center h-full px-6">
          <h1 className="text-white text-2xl font-bold mb-2 leading-tight">
            Everything Your<br />Family Needs
          </h1>
          <p className="text-white/90 text-sm mb-4 max-w-xs">
            Discover quality clothes, shoes, jewelry, and household items all in one place
          </p>
          <Button variant="primary" size="sm" className="w-fit">
            Shop Now
          </Button>
        </div>
      </div>
    </section>
  );
};
